import { Component, ChangeDetectorRef, OnInit, Input } from '@angular/core';
import { Wrapper } from '../wrapper.component';
import { BrandFormType, BrandFormTypeNames, BrandOption, BrandType, BrandingData, BrandingSelectData, brandFormTypeList, brandFormTypesMap } from 'globals/store/publish.data';
import { brandDataReselector } from '../../store/reselectors/publish.reselector';
import { ManageBrandingComponent, ManageBrandingData } from './manage-branding.component';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { JoiEvent } from 'globals/store/events.data';
import { removeOrAddToListByElement } from '../../helpers/helpers';
import { clipboardEditingPrivilegesReselector } from '../../store/reselectors/accounts.reselector';
import { LoaderPaneFragmentComponent } from '../loader/loader-pane-fragment.component';
import { BrandImageComponent } from './brand-image.component';
import { BrandingBlockWrapperComponent } from './branding-block.component';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { SocialLinksComponent } from '../social-links/social-links.component';
import { TopMenuComponent } from 'src/app/modules/program/top.menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BrandTemplateComponent } from './brand-template.component';
import { CommonModule, UpperCasePipe } from '@angular/common';
import { ListHasStringPipe } from 'src/app/services/pipes/listHasString.pipe';


@Component({
    selector: 'branding',
    template: `
<top-menu></top-menu>
<div class="checks" *ngIf="!!event">
  <div class="check-holder" *ngFor="let formType of brandFormTypeList">
    <mat-checkbox color="primary" (change)="toggleFormType(formType)" [checked]="!(event.ignoredForms | listHasString:formType)"></mat-checkbox>
    <div class="label" >{{ brandFormTypeNames[formType] }}</div>
  </div>
</div>
<div class="blocks" *ngIf="!!brandingData">
  <branding-block
    [title]="'Fonts and Colors'"
    [greyText]="brandingData.template?.id === 'joi' ? 'DEFAULT SELECTED' : ((brandingData.template?.name || 'Unnamed Fonts and Colors Template') | uppercase) + ' SELECTED'"
    [changeText]="!canEditAccount ? '+ CHANGE IN BRAND OPTIONS' : '+ CHANGE/ADD IN BRAND OPTIONS'"
    (change)="change('template')"
  >
    <brand-template *ngIf="!!brandingData.template"
      [template]="brandingData.template"
      [selectedViewOnly]="true"
      [readOnly]="true"
    ></brand-template>
  </branding-block>
  <branding-block
    [title]="'Header'"
    [greyText]="!brandingData.header ? 'NONE SELECTED' : ((brandingData.header.name || 'Unnamed Header Image Set') | uppercase) + ' SELECTED'"
    [changeText]="!brandingData.header ? '+ ADD FROM BRAND OPTIONS' : !canEditAccount ? '+ CHANGE IN BRAND OPTIONS' : '+ CHANGE/ADD IN BRAND OPTIONS'"
    (change)="change('header')"
  ><brand-image *ngIf="!!brandingData.header" [readOnly]="true" [template]="brandingData.header"></brand-image>
  </branding-block>
  <branding-block
    [title]="'Social links'"
    [greyText]="!brandingData?.social ? 'NONE SELECTED' : ((brandingData.social.name || 'Unnamed Social Links Set') | uppercase) + ' SELECTED'"
    [changeText]="!brandingData?.social ? '+ ADD FROM BRAND OPTIONS' : !canEditAccount ? '+ CHANGE IN BRAND OPTIONS' :  '+ CHANGE/ADD IN BRAND OPTIONS'"
    (change)="change('social')"
  >
    <social-links [socialLinks]="brandingData.social?.social"></social-links>
  </branding-block>
  <branding-block
    [title]="'Footer'"
    [greyText]="!brandingData.footer ? 'NONE SELECTED' : ((brandingData.footer.name || 'Unnamed Footer Image Set') | uppercase) + ' SELECTED'"
    [changeText]="!brandingData.footer ? '+ ADD FROM BRAND OPTIONS' : !canEditAccount ? '+ CHANGE IN BRAND OPTIONS' : '+ CHANGE/ADD IN BRAND OPTIONS'"
    (change)="change('footer')"
  ><brand-image *ngIf="!!brandingData.footer" [readOnly]="true" [template]="brandingData.footer"></brand-image>
  </branding-block>
</div>
<loader-pane-fragment [trace]="traceNames.viewShareBranding"></loader-pane-fragment>
`,
    styleUrls: ['../../page.scss'],
    styles: [`
    .blocks { padding: 40px 40px 0; background: white; margin-top: 20px; border-radius: 6px; }
    branding-block { width: 100%; margin-bottom: 40px; }
    brand-template { margin-top: 40px; }
    .checks { margin: 20px 20px 0; display: grid; grid-template-columns: repeat(3, 1fr); }
    .check-holder { display: flex; align-items: center; }
    .checks .label { margin: 0 0 1px 5px; font-size: 11px; font-weight: bold; text-transform: uppercase; }
  `],
    standalone: true,
    imports: [LoaderPaneFragmentComponent, CommonModule, BrandImageComponent, SocialLinksComponent, TopMenuComponent, MatCheckboxModule, BrandTemplateComponent, UpperCasePipe, ListHasStringPipe, BrandingBlockWrapperComponent],
})
export class BrandingComponent extends Wrapper<BrandingComponent> implements OnInit {
  @Input() publishId: string
  @Input() eventListId: string
  brandFormTypeList = brandFormTypeList
  brandFormTypeNames = BrandFormTypeNames
  traceNames = traceNames
  event: JoiEvent
  brandingData: BrandingData
  canEditAccount: boolean

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super()
  }

  ngOnInit() {
    const brandingSelectData: BrandingSelectData = {
      type: 'forms',
      publishId: this.publishId
    }

    this.selectProp(brandDataReselector, brandingSelectData, 'brandingData')
    this.selectProp(clipboardEditingPrivilegesReselector, null, 'canEditAccount')
    this.subProp(this.store.select('events', 'event'), 'event')
  }

  toggleFormType(type: BrandFormType) {
    const ignoredForms = this.event.ignoredForms
    removeOrAddToListByElement(ignoredForms, type)
    this.eventService.updateEvent(this.event.eventId, { ignoredForms })
  }

  async change(brandingOption: BrandOption) {
    console.log("Should be opening branding options dialogue and changing " + brandingOption)
    const data: ManageBrandingData = { selectedTab: brandingOption, type: 'forms', publishId: this.publishId, onAccount: this.canEditAccount  }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageBrandingComponent, { disableClose: true, autoFocus: false, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

}

